import { numberFormattingContext } from "app/formatting/context";
import { formatDateOrTime, formatMoney, formatTime } from "app/formatting/functions";
import React from "react";

import "./style.scss";
import { chartPeriods } from "app/charts/types";
import { CHART_CANVAS_WIDTH } from "app/charts/constants";

export interface Props {
    period: chartPeriods;
    // => fixedX, fixedY, moneyValue, dateValue
    getData: (x: number, targetWidth: number, targetHeight: number) => [number, number, number, number];
}

export const ChartInteractiveLayer = ({ period, getData }: Props) => {
    const [[x, y, money, date], setState] = React.useState([0, 0, 0, 0]);
    const [isMobileActive, setIsMobileActive] = React.useState(false);
    const fractionDigits = React.useContext(numberFormattingContext).fractionDigits;
    const classNames = ["chartInteractiveLayer"];

    if (isMobileActive) {
        classNames.push("active");
    }

    const handler = (e: any) => {
        const bBox = e.currentTarget.getBoundingClientRect();
        const xValue = (e.pageX - bBox.left) / (bBox.width / 100);

        setState(getData(xValue, bBox.width, bBox.height));
    };

    const handlerTouch = (e: any) => {
        if (!isMobileActive) {
            setIsMobileActive(true);
        }
        const bBox = e.currentTarget.getBoundingClientRect();
        setState(getData((e.changedTouches[0].pageX - bBox.x) / (bBox.width / 100), bBox.width, bBox.height));
    };

    const handleTouchEnd = () => {
        setTimeout(() => setIsMobileActive(false), 500);
    };

    return (
        <div
            className={classNames.join(" ")}
            onMouseMove={handler}
            onTouchMove={handlerTouch}
            onTouchEnd={handleTouchEnd}
        >
            <div className="xMarker" style={{ transform: `translateX(${x - 8}px)` }}>
                <div className="yMarker" style={{ transform: `translate(-50%, ${y}px)` }}>
                    <div
                        className="yMarkerRadient"
                        style={{
                            background:
                                "linear-gradient(180deg, rgba(2,0,36,1) 0%, rgba(255,255,255,1) calc(90% - " +
                                y +
                                "px))"
                        }}
                    ></div>
                </div>
            </div>
            <div className="yLabel" style={{ left: `${x}px`, transform: `translateY(${y}px)` }}>
                <div className="label">
                    <b>{formatMoney(money, "", fractionDigits)}</b>
                    {period === chartPeriods.INTRADAY ? formatTime(date) : formatDateOrTime(date)}
                </div>
            </div>
        </div>
    );
};
